import React from 'react'
import { Link } from 'react-router-dom'

import AiAssistantPage, { CheckList, Steps, CodeBlock, Section } from './ai-assistant-page'

const CONNECTOR_URL = 'https://sms.dataflows.com.au/mcp/claude'

const ClaudeIntegration = () => (
  <AiAssistantPage
    slug="claude"
    name="Claude"
    badge="Claude Connector"
    title="Claude SMS Connector | DataFlows"
    description="Send, schedule and track business SMS from your DataFlows account by asking Claude in plain language. Works in Claude on the web, desktop and mobile apps, and Claude Code."
    heading="DataFlows SMS for Claude"
    intro="Send, schedule and track business SMS from your DataFlows account by asking Claude in plain language. The DataFlows SMS connector works in Claude on the web, the Claude desktop and mobile apps, and Claude Code."
    disconnect="In Claude, go to Customize, then Connectors, select DataFlows SMS and select Disconnect. Disconnecting stops access straight away."
    relatedLink={<Link to="/integrations/chatgpt" className="cliniko-related-link">ChatGPT SMS</Link>}
    heroAction={
      <a href="https://claude.ai/directory/connectors/dataflows-sms" target="_blank" rel="noreferrer noopener" className="cliniko-btn-primary">
        Connect to Claude
      </a>
    }
  >
    <Section label="Requirements" title="What you need">
      <CheckList items={[
        'A DataFlows account with SMS credits',
        'A sender ID or number on your account (your default sender is used unless you choose another)',
        'A Claude account',
      ]} />
    </Section>

    <Section label="Setup" title="Connect in Claude" id="connect" dark>
      <Steps items={[
        'In Claude, go to Customize, then Connectors.',
        'Find DataFlows SMS in the directory (or open the listing directly with the Connect to Claude button above) and select Connect.',
        'Sign in with your DataFlows login and select Allow Access.',
        'In a chat, turn the connector on from the + menu, under Connectors.',
      ]} />
    </Section>

    <Section label="Setup" title="Connect in Claude Code">
      <p className="ai-body-text">Run this command, then type /mcp in Claude Code and sign in when prompted:</p>
      <CodeBlock code={`claude mcp add --transport http dataflows-sms ${CONNECTOR_URL}`} />

      <h3 className="ai-subheading">Or install the DataFlows SMS plugin</h3>
      <p className="ai-body-text">The official DataFlows plugin adds the same connector plus guided skills that confirm every send and preview costs before campaigns.</p>
      <CodeBlock code={`/plugin marketplace add dataflows-au/dataflows-sms-claude-plugin\n/plugin install dataflows-sms@dataflows`} />
      <p className="ai-body-text ai-body-link">
        <a href="https://github.com/dataflows-au/dataflows-sms-claude-plugin" target="_blank" rel="noreferrer noopener" className="cliniko-inline-link">View the plugin on GitHub</a>
      </p>
    </Section>
  </AiAssistantPage>
)

export default ClaudeIntegration
